<template>
  <back-office-form
    :inputs="inputs"
    :item="game"
    :delete-button-label="this.$t('games.delete')"
    delete-confirmation-attribute="name"
    :mode="mode"
    :modes="modes"
    @submit="handleSubmit"
    @delete="handleDelete"
  />
</template>

<script>
  import BackOfficeForm from '@/components/BackOfficeForm'
  import { MInputPercentage } from 'codefabrik-gui-vue'
  import PercentageInput from '@/components/PercentageInput'

  export default {
    name: 'GameForm',
    components: { BackOfficeForm },
    props: {
      game: {
        type: Object,
        default: () => {
          return {}
        }
      },
      mode: {
        type: String,
        required: true
      }
    },
    methods: {
      handleSubmit (...rest) {
        this.$emit('submit', ...rest)
      },
      handleDelete () {
        this.$emit('delete')
      }
    },
    computed: {
      modes () {
        return {
          create: {
            title: 'games.add',
            subtitles: ['games.addDescription1', 'games.addDescription2']
          },
          edit: {
            title: 'games.edit',
            subtitles: ['']
          }
        }
      },
      inputs () {
        return [
          {
            name: 'name',
            validators: 'required',
            properties: {
              placeholder: this.$t('games.newGamePlaceholder'),
              label: this.$t('common.name')
            }
          },
          {
            name: 'gameId',
            validators: 'required',
            properties: {
              placeholder: this.$t('games.gameIdPlaceholder'),
              label: this.$t('games.gameId')
            }
          },
          {
            name: 'theoreticalReturnToPlayer',
            is: PercentageInput,
            validators: 'required',
            properties: {
              placeholder: this.$t('games.theoreticalReturnToPlayerPlaceholder'),
              label: this.$t('games.theoreticalReturnToPlayer')
            }
          }
        ]
      }
    }
  }
</script>

<style scoped>
</style>
